import { create } from 'zustand';
import { TOKEN_KEY } from '@/utils/cookie';

interface AuthStore {
  token: any,
  setAuthToken: (token:any) => void,
}

const useAuthStore = create<AuthStore>((set) => {
  let token = null;
  if (localStorage.getItem(TOKEN_KEY)) {
    token = JSON.parse(localStorage.getItem(TOKEN_KEY));
  }
  
  return {
    token: token,
    setAuthToken: (token) => set({token: token}),
  };
});

export { useAuthStore };